import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../../directives/directives.module';
import { DropdownComponent } from './dropdown.component';
import { TemplateModule } from '../template/template.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';

@NgModule({
  declarations: [DropdownComponent],
  entryComponents: [DropdownComponent],
  exports: [DropdownComponent],
  imports: [CommonModule, DirectivesModule, TemplateModule, PipesModule, ScrollbarModule]
})
export class DropdownModule {}

export { DropdownComponent };
